import React from 'react';
import wb0 from '../img/Detail/wattlebird_detail.jpg';
import './Detail.css';
const WattlebirdDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default WattlebirdDetail;